import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const resources = {
  en: {
    translation: {
      appTitle: 'VidyShort', appSubtitle: 'Stream. Discover. Connect.',
      welcome: 'Welcome to VidyShort', movies: 'Movies', series: 'Series',
      shortDrama: 'Short Drama', podcasts: 'Podcasts', genres: 'Genres',
      login: 'Login', signIn: 'Sign In', signUp: 'Sign Up',
      createAccount: 'Create Account', haveAccount: 'Already have an account? Sign in',
      noAccount: "Don't have an account? Sign up",
      email: 'Email', password: 'Password', username: 'Username',
      enterEmail: 'Enter your email', enterPassword: 'Enter your password',
      enterUsername: 'Enter your username', forgotPassword: 'Forgot Password?',
      pleaseFillAllFields: 'Please fill in all fields',
      pleaseEnterUsername: 'Please enter a username',
      usernameMinLength: 'Username must be at least 3 characters',
      usernameMaxLength: 'Username must be less than 20 characters',
      passwordMinLength: 'Password must be at least 6 characters',
      validEmail: 'Please enter a valid email address',
      emailAlreadyRegistered: 'This email is already registered.',
      invalidCredentials: 'Invalid email or password.',
      checkEmailToVerify: 'Check your email to verify your account.',
      confirmEmail: 'Please confirm your email first.',
      checkSpamFolder: 'Check your spam folder if you don\'t see it.',
      resendEmail: 'Resend Email', verificationEmailResent: 'Verification email resent!',
      verificationFailed: 'Verification failed.', error: 'Error', success: 'Success',
      ok: 'OK', cancel: 'Cancel', somethingWrong: 'Something went wrong.',
      passwordHint: 'At least 6 characters', info: 'Info',
      passwordResetSoon: 'Password reset coming soon.',
      admin: 'Admin', profile: 'Profile',
      welcomeBack: 'Welcome back,', welcomeAdmin: 'Welcome, Admin',
      loadingContent: 'Loading content...', verifyingAccess: 'Verifying access...',
      checkBackLater: 'Check back later for new content.',
      clearFilter: 'Clear', accessDenied: 'Access Denied',
      logout: 'Logout', logoutConfirm: 'Are you sure you want to logout?',
      memberSince: 'Member since', editProfile: 'Edit Profile',
      account: 'Account', support: 'Support',
      requestMovie: 'Request a Video', requestMovieDesc: 'Suggest content you\'d like to see',
      likedVideos: 'Liked Videos', likedVideosDesc: 'Your favourite content',
      settings: 'Settings', settingsDesc: 'App preferences and options',
      contactSupport: 'Contact Support', contactSupportDesc: 'support@vidyshort.app',
      termsPrivacy: 'Terms & Privacy', termsPrivacyDesc: 'View our terms of service',
      videos: 'Videos', likes: 'Liked', comments: 'Comments', requests: 'Requests',
      views: 'Views', browseAsGuest: 'Browse as Guest',
      continueAsGuest: 'Continue as Guest', guestHint: 'Browse & watch · No account needed',
      signingIn: 'Signing in...', creatingAccount: 'Creating account...',
    }
  },
  sw: {
    translation: {
      appTitle: 'VidyShort', appSubtitle: 'Tazama. Gundua. Unganika.',
      welcome: 'Karibu VidyShort', movies: 'Filamu', series: 'Vipindi',
      shortDrama: 'Drama Fupi', podcasts: 'Podcasti',
      login: 'Ingia', signIn: 'Ingia', signUp: 'Jisajili',
      createAccount: 'Tengeneza Akaunti', haveAccount: 'Tayari una akaunti? Ingia',
      noAccount: 'Huna akaunti? Jisajili',
      email: 'Barua Pepe', password: 'Nenosiri', username: 'Jina la Mtumiaji',
      enterEmail: 'Ingiza barua pepe', enterPassword: 'Ingiza nenosiri',
      enterUsername: 'Ingiza jina la mtumiaji', forgotPassword: 'Umesahau nenosiri?',
      pleaseFillAllFields: 'Tafadhali jaza sehemu zote',
      usernameMinLength: 'Jina lazima liwe na herufi 3+',
      passwordMinLength: 'Nenosiri lazima liwe na herufi 6+',
      loadingContent: 'Inapakia...', clearFilter: 'Futa',
      logout: 'Toka', logoutConfirm: 'Una uhakika unataka kutoka?',
      memberSince: 'Mwanachama tangu', editProfile: 'Hariri Wasifu',
      account: 'Akaunti', support: 'Msaada',
      requestMovie: 'Omba Video', requestMovieDesc: 'Pendekeza maudhui unayotaka',
      videos: 'Video', likes: 'Zilizopendwa', comments: 'Maoni', requests: 'Maombi',
      continueAsGuest: 'Endelea kama Mgeni', guestHint: 'Tazama bila akaunti',
      ok: 'Sawa', cancel: 'Ghairi', error: 'Hitilafu', success: 'Mafanikio',
      admin: 'Msimamizi', profile: 'Wasifu',
    }
  }
}

i18n.use(initReactI18next).init({
  resources, lng: 'en', fallbackLng: 'en',
  interpolation: { escapeValue: false }
})

export default i18n